import type { CardDefinition } from "../domain/types/index.js";

export const MEDIUM_PROGRESS_CARDS = {
  "crash-work": {
    id: "crash-work", name: "突貫工事", type: "action",
    text: "進捗+3", rewardTier: "medium",
    effect: { kind: "progress", amount: 3 },
  },
  "no-overtime-day": {
    id: "no-overtime-day", name: "ノー残業デー", type: "action",
    text: "進捗+2。疲労-1", rewardTier: "medium",
    effect: {
      kind: "compound",
      effects: [{ kind: "progress", amount: 2 }, { kind: "heal", amount: 1 }],
    },
  },
} as const satisfies Record<string, CardDefinition>;
